// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuperAdminCandidates_page__bT0Bs { max-width: 1600px; }
.SuperAdminCandidates_pageHeader__cLo5q { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 1.25rem; gap: 1rem; flex-wrap: wrap; position: sticky; top: 0; background: var(--gray-50); padding: 0.5rem 0; z-index: 50; }
.SuperAdminCandidates_pageTitle__IARdO { font-size: 1.4rem; color: var(--black); margin-bottom: 0.2rem; }
.SuperAdminCandidates_pageSub__OhQBI { font-size: 0.8rem; color: var(--gray-500); }

.SuperAdminCandidates_filterBtn__sKjOL { padding: 0.4rem 0.85rem; background: transparent; border: 1px solid var(--border); border-radius: 100px; font-size: 0.78rem; color: var(--gray-700); transition: all 0.12s; }
.SuperAdminCandidates_filterBtn__sKjOL:hover { background: var(--gray-50); }
.SuperAdminCandidates_filterBtn__sKjOL.SuperAdminCandidates_active__8irBz { background: var(--green); color: white; border-color: var(--green); }
.SuperAdminCandidates_filterCount__LxF9D { opacity: 0.7; font-size: 0.7rem; color: #dc2626; margin-left: 0.3rem; }
.SuperAdminCandidates_filterBtn__sKjOL.SuperAdminCandidates_active__8irBz .SuperAdminCandidates_filterCount__LxF9D { color: white; }

.SuperAdminCandidates_searchBar__8oa5F { margin-bottom: 1.25rem; display: flex; align-items: center; gap: 1rem; flex-wrap: wrap; }
.SuperAdminCandidates_filtersInline__Csv2R { display: flex; gap: 0.5rem; flex-wrap: wrap; }
.SuperAdminCandidates_searchInput__BXcVK { padding: 0.6rem 1rem; border: 1px solid var(--border); border-radius: var(--radius); font-size: 0.82rem; color: var(--gray-900); transition: border-color 0.15s; flex: 1 1; min-width: 200px; }
.SuperAdminCandidates_searchInput__BXcVK:focus { outline: none; border-color: var(--green); }
.SuperAdminCandidates_searchInput__BXcVK::placeholder { color: var(--gray-400); }

.SuperAdminCandidates_successBox__xX8Bi {
  border: 1px solid rgba(26,92,56,0.25);
  border-radius: var(--radius-lg);
  background: var(--green-light);
  margin-bottom: 1.25rem;
  padding: 0.85rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  animation: SuperAdminCandidates_slideDown__44b63 0.3s ease;
}

.SuperAdminCandidates_successContent__UVfmy {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.SuperAdminCandidates_successIcon__BWDRD {
  font-size: 1rem;
  color: var(--green);
  font-weight: bold;
}

.SuperAdminCandidates_successText__Bxdc6 {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--green);
}

@keyframes SuperAdminCandidates_slideDown__44b63 {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.SuperAdminCandidates_table__qMpuH {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  overflow: hidden;
}

.SuperAdminCandidates_table__qMpuH thead {
  background: var(--gray-50);
  border-bottom: 1px solid var(--border);
}

.SuperAdminCandidates_table__qMpuH th {
  padding: 0.85rem 1rem;
  text-align: left;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--gray-700);
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.SuperAdminCandidates_table__qMpuH tbody tr {
  border-top: 1px solid var(--border);
  transition: background 0.15s;
}

.SuperAdminCandidates_table__qMpuH tbody tr:hover {
  background: var(--gray-50);
}

.SuperAdminCandidates_table__qMpuH td {
  padding: 0.85rem 1rem;
  font-size: 0.82rem;
  color: var(--gray-900);
}

.SuperAdminCandidates_candidateCell__rqJhE {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.SuperAdminCandidates_candidateName__DCy7A {
  font-weight: 500;
  color: var(--black);
}

.SuperAdminCandidates_candidateEmail__ld02u {
  font-size: 0.75rem;
  color: var(--gray-500);
  margin-top: 0.15rem;
}

.SuperAdminCandidates_roleTag__upE0D {
  display: inline-block;
  padding: 0.35rem 0.75rem;
  background: #f0f9ff;
  color: #0369a1;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

.SuperAdminCandidates_statusTag__LKRcS {
  display: inline-block;
  padding: 0.35rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

.SuperAdminCandidates_statusTag__LKRcS.SuperAdminCandidates_pending__PL46m {
  background: #fef3c7;
  color: #b45309;
}

.SuperAdminCandidates_statusTag__LKRcS.SuperAdminCandidates_inProgress__fo5EW {
  background: #dbeafe;
  color: #0369a1;
}

.SuperAdminCandidates_statusTag__LKRcS.SuperAdminCandidates_completed__Bo5TS {
  background: #dcfce7;
  color: #166534;
}

.SuperAdminCandidates_muted__4snxv {
  color: var(--gray-500);
  font-size: 0.8rem;
}

.SuperAdminCandidates_cameraToggleBtn__L8IC1 {
  padding: 0.4rem 0.65rem;
  border: 1px solid var(--border);
  background: white;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.15s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  height: 34px;
}

.SuperAdminCandidates_cameraToggleBtn__L8IC1:hover:not(:disabled) {
  border-color: var(--green);
  background: var(--green-light);
}

.SuperAdminCandidates_cameraToggleBtn__L8IC1.SuperAdminCandidates_required__iT5rY {
  border-color: var(--green);
  color: var(--green);
}

.SuperAdminCandidates_cameraToggleBtn__L8IC1.SuperAdminCandidates_notRequired__1wn8R {
  border-color: #dc2626;
  color: #dc2626;
}

.SuperAdminCandidates_cameraToggleBtn__L8IC1:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.SuperAdminCandidates_loadingContainer__zZ4SJ {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  text-align: center;
}

.SuperAdminCandidates_loadingText__czVIJ {
  color: var(--gray-500);
  font-size: 0.9rem;
}

.SuperAdminCandidates_emptyContainer__4V3dh {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  text-align: center;
}

.SuperAdminCandidates_emptyText__qaKU- {
  color: var(--gray-500);
  font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/SuperAdminCandidates.module.css"],"names":[],"mappings":"AAAA,oCAAQ,iBAAiB,EAAE;AAC3B,0CAAc,aAAa,EAAE,uBAAuB,EAAE,8BAA8B,EAAE,sBAAsB,EAAE,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,MAAM,EAAE,0BAA0B,EAAE,iBAAiB,EAAE,WAAW,EAAE;AAChO,yCAAa,iBAAiB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AAC5E,uCAAW,iBAAiB,EAAE,sBAAsB,EAAE;;AAEtD,yCAAa,uBAAuB,EAAE,uBAAuB,EAAE,+BAA+B,EAAE,oBAAoB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,qBAAqB,EAAE;AACzL,+CAAmB,0BAA0B,EAAE;AAC/C,4EAAoB,wBAAwB,EAAE,YAAY,EAAE,0BAA0B,EAAE;AACxF,2CAAe,YAAY,EAAE,iBAAiB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACrF,qHAAiC,YAAY,EAAE;;AAE/C,yCAAa,sBAAsB,EAAE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE;AACrG,6CAAiB,aAAa,EAAE,WAAW,EAAE,eAAe,EAAE;AAC9D,2CAAe,oBAAoB,EAAE,+BAA+B,EAAE,4BAA4B,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,8BAA8B,EAAE,SAAO,EAAE,gBAAgB,EAAE;AAC3M,iDAAqB,aAAa,EAAE,0BAA0B,EAAE;AAChE,wDAA4B,sBAAsB,EAAE;;AAEpD;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,0DAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB","sourcesContent":[".page { max-width: 1600px; }\n.pageHeader { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 1.25rem; gap: 1rem; flex-wrap: wrap; position: sticky; top: 0; background: var(--gray-50); padding: 0.5rem 0; z-index: 50; }\n.pageTitle { font-size: 1.4rem; color: var(--black); margin-bottom: 0.2rem; }\n.pageSub { font-size: 0.8rem; color: var(--gray-500); }\n\n.filterBtn { padding: 0.4rem 0.85rem; background: transparent; border: 1px solid var(--border); border-radius: 100px; font-size: 0.78rem; color: var(--gray-700); transition: all 0.12s; }\n.filterBtn:hover { background: var(--gray-50); }\n.filterBtn.active { background: var(--green); color: white; border-color: var(--green); }\n.filterCount { opacity: 0.7; font-size: 0.7rem; color: #dc2626; margin-left: 0.3rem; }\n.filterBtn.active .filterCount { color: white; }\n\n.searchBar { margin-bottom: 1.25rem; display: flex; align-items: center; gap: 1rem; flex-wrap: wrap; }\n.filtersInline { display: flex; gap: 0.5rem; flex-wrap: wrap; }\n.searchInput { padding: 0.6rem 1rem; border: 1px solid var(--border); border-radius: var(--radius); font-size: 0.82rem; color: var(--gray-900); transition: border-color 0.15s; flex: 1; min-width: 200px; }\n.searchInput:focus { outline: none; border-color: var(--green); }\n.searchInput::placeholder { color: var(--gray-400); }\n\n.successBox {\n  border: 1px solid rgba(26,92,56,0.25);\n  border-radius: var(--radius-lg);\n  background: var(--green-light);\n  margin-bottom: 1.25rem;\n  padding: 0.85rem 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  animation: slideDown 0.3s ease;\n}\n\n.successContent {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.successIcon {\n  font-size: 1rem;\n  color: var(--green);\n  font-weight: bold;\n}\n\n.successText {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--green);\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  overflow: hidden;\n}\n\n.table thead {\n  background: var(--gray-50);\n  border-bottom: 1px solid var(--border);\n}\n\n.table th {\n  padding: 0.85rem 1rem;\n  text-align: left;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--gray-700);\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.table tbody tr {\n  border-top: 1px solid var(--border);\n  transition: background 0.15s;\n}\n\n.table tbody tr:hover {\n  background: var(--gray-50);\n}\n\n.table td {\n  padding: 0.85rem 1rem;\n  font-size: 0.82rem;\n  color: var(--gray-900);\n}\n\n.candidateCell {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.candidateName {\n  font-weight: 500;\n  color: var(--black);\n}\n\n.candidateEmail {\n  font-size: 0.75rem;\n  color: var(--gray-500);\n  margin-top: 0.15rem;\n}\n\n.roleTag {\n  display: inline-block;\n  padding: 0.35rem 0.75rem;\n  background: #f0f9ff;\n  color: #0369a1;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.statusTag {\n  display: inline-block;\n  padding: 0.35rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.statusTag.pending {\n  background: #fef3c7;\n  color: #b45309;\n}\n\n.statusTag.inProgress {\n  background: #dbeafe;\n  color: #0369a1;\n}\n\n.statusTag.completed {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.muted {\n  color: var(--gray-500);\n  font-size: 0.8rem;\n}\n\n.cameraToggleBtn {\n  padding: 0.4rem 0.65rem;\n  border: 1px solid var(--border);\n  background: white;\n  border-radius: 6px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.15s;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 44px;\n  height: 34px;\n}\n\n.cameraToggleBtn:hover:not(:disabled) {\n  border-color: var(--green);\n  background: var(--green-light);\n}\n\n.cameraToggleBtn.required {\n  border-color: var(--green);\n  color: var(--green);\n}\n\n.cameraToggleBtn.notRequired {\n  border-color: #dc2626;\n  color: #dc2626;\n}\n\n.cameraToggleBtn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  text-align: center;\n}\n\n.loadingText {\n  color: var(--gray-500);\n  font-size: 0.9rem;\n}\n\n.emptyContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  text-align: center;\n}\n\n.emptyText {\n  color: var(--gray-500);\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `SuperAdminCandidates_page__bT0Bs`,
	"pageHeader": `SuperAdminCandidates_pageHeader__cLo5q`,
	"pageTitle": `SuperAdminCandidates_pageTitle__IARdO`,
	"pageSub": `SuperAdminCandidates_pageSub__OhQBI`,
	"filterBtn": `SuperAdminCandidates_filterBtn__sKjOL`,
	"active": `SuperAdminCandidates_active__8irBz`,
	"filterCount": `SuperAdminCandidates_filterCount__LxF9D`,
	"searchBar": `SuperAdminCandidates_searchBar__8oa5F`,
	"filtersInline": `SuperAdminCandidates_filtersInline__Csv2R`,
	"searchInput": `SuperAdminCandidates_searchInput__BXcVK`,
	"successBox": `SuperAdminCandidates_successBox__xX8Bi`,
	"slideDown": `SuperAdminCandidates_slideDown__44b63`,
	"successContent": `SuperAdminCandidates_successContent__UVfmy`,
	"successIcon": `SuperAdminCandidates_successIcon__BWDRD`,
	"successText": `SuperAdminCandidates_successText__Bxdc6`,
	"table": `SuperAdminCandidates_table__qMpuH`,
	"candidateCell": `SuperAdminCandidates_candidateCell__rqJhE`,
	"candidateName": `SuperAdminCandidates_candidateName__DCy7A`,
	"candidateEmail": `SuperAdminCandidates_candidateEmail__ld02u`,
	"roleTag": `SuperAdminCandidates_roleTag__upE0D`,
	"statusTag": `SuperAdminCandidates_statusTag__LKRcS`,
	"pending": `SuperAdminCandidates_pending__PL46m`,
	"inProgress": `SuperAdminCandidates_inProgress__fo5EW`,
	"completed": `SuperAdminCandidates_completed__Bo5TS`,
	"muted": `SuperAdminCandidates_muted__4snxv`,
	"cameraToggleBtn": `SuperAdminCandidates_cameraToggleBtn__L8IC1`,
	"required": `SuperAdminCandidates_required__iT5rY`,
	"notRequired": `SuperAdminCandidates_notRequired__1wn8R`,
	"loadingContainer": `SuperAdminCandidates_loadingContainer__zZ4SJ`,
	"loadingText": `SuperAdminCandidates_loadingText__czVIJ`,
	"emptyContainer": `SuperAdminCandidates_emptyContainer__4V3dh`,
	"emptyText": `SuperAdminCandidates_emptyText__qaKU-`
};
export default ___CSS_LOADER_EXPORT___;
